import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
  ColumnSortEvent,
} from 'primereact/column';
import { TableDropdownFilter } from '@/components';
import { TableData } from '@/components/Table/types';
import { UnloadingInfo } from '../types';

export const getTableColumns = (
  data: UnloadingInfo[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'armador',
      header: 'Armador',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'contenedor',
      header: 'Contenedor',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => <b>{rowData.contenedor}</b>,
    },
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'peso',
      header: 'Peso (Kg)',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto1',
      header: 'Precinto 1',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      sortFunction: (event: ColumnSortEvent) =>
        event.data.sort(
          (itemA: UnloadingInfo, itemB: UnloadingInfo) =>
            (itemA.precinto1 < itemB.precinto1 ? -1 : 1) * (event.order || 1)
        ),
    },
    {
      field: 'precinto2',
      header: 'Precinto 2',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto3',
      header: 'Precinto 3',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto4',
      header: 'Precinto 4',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'imos',
      header: 'Imos',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'uns',
      header: 'UNs',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'temperatura',
      header: 'Temp',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) =>
        rowData.temperatura !== null ? `${rowData.temperatura} °C` : '',
    },
    {
      field: 'ventilacion',
      header: 'Vent',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'humedad',
      header: 'Hum',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'status',
      header: 'St',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'destinoFinal',
      header: 'Destino',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'viajeCarga',
      header: 'Buque de carga',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};
